<template>
    <div>
        <div class="stepsBox">
            <div class="steps">
                <div class="first">1</div >
                <p>上传文件与位置签署方</p>
            </div>
            <div style="margin: 0px 10px;color: #61686e">——</div>
            <div class="setUp">
                <div class="second">2</div>
                <p>设置签署位置并发起合同</p>
            </div>
        </div>
        <div class="uploadFilesBox">
            <div class="uploadTitle">
                <p>上传合同文件</p>
                <span>剩余合同份数: <span style="color: #1e57dc;font-weight: 500">20</span> 份
                </span>
            </div>
            <div class="uploadBox">
                <el-upload
                        class="upload-demo"
                        drag
                        :limit="1"
                        accept=".pdf,.jpg,.png"
                        :before-upload="beforeAvatarUpload"
                        action=""
                        multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">请上传合同文件(加密文件请转成普通文件再上传)
                        <div class="el-upload__tip" slot="tip">最多上传1份文件,单份文件小于5M,支持.pdf,.jpg,.png</div>
                    </div>
                </el-upload>
                <div class="titleBox">
                    <div class="title">
                        <p>合同标题</p>
                        <el-input  placeholder="请输入内容"></el-input>
                    </div>
                    <div class="expirationDate">
                        <p>签订截止日期</p>
                        <el-date-picker
                                v-model="expiration"
                                type="datetime"
                                placeholder="选择日期时间"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="signatoryBox">
            <div class="signatory">
                <p>设置签署方</p>
                <div class="signatoryTab">
                    <el-tabs v-model="activeName" >
                        <el-tab-pane label="单方签署" name="first">
                            <unilateral></unilateral>
                        </el-tab-pane>
                        <el-tab-pane label="双方签署" name="second">
                            <bothSides></bothSides>
                        </el-tab-pane>
                        <el-tab-pane label="多方签署" name="third">
                            <many></many>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import unilateral from './components/unilateral'
    import bothSides from "./components/bothSides";
    import many from './components/many'
    export default {
        name: "initiatingContract",
        data(){
          return{
              activeName: 'first',
              expiration:'',  //截止日期
              pickerOptions: {
                  disabledDate(time) {
                      return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
                  }
              },
          }
        },
        methods:{
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isLt2M) {
                    this.$message.error('上传文件大小不能超过 5MB!');
                }
                return isLt2M;
            }
        },
        components:{
            unilateral,
            bothSides,
            many
        }
    }
</script>

<style scoped>
    .stepsBox{
        width: 100%;
        height: 100px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .steps,
    .setUp{
        display: flex;
        align-items: center;
    }
    .first{
        width: 40px;
        height: 40px;
        color: #fff;
        border-radius: 50%;
        background-color: #1e57dc;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        font-weight: 600;
    }
    .second{
        width: 40px;
        height: 40px;
        color: #fff;
        border-radius: 50%;
        background-color: #a8abb0;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        font-weight: 600;
    }
    .steps>p,
    .setUp>p{
        margin: 0px 10px;
        color: #61686e;
    }
    .uploadFilesBox{
        margin: 20px 0px;
        /*height: 300px;*/
        background-color: #fff;
    }
    .uploadTitle{
        display: flex;
        align-items: center;
        margin: 0px 30px;
        padding: 20px 0px;
    }
    .uploadTitle>P{
        font-size: 18px;
        margin-right: 30px;
    }
    .uploadTitle>span{
        color: #babdc1;
    }
    .uploadBox{
        width: 95%;
        margin: auto;
    }
    /deep/.el-upload{
        width: 100%;
    }
    /deep/.el-upload-dragger{
        border: 0px;
        width: 100%;
    }

    .titleBox{
        padding: 20px 0px;
        display: flex;
        align-items: center;
    }
    .title{
        width: 40%;
        display: flex;
        align-items: center;
    }
    .title>p{
        width: 25%;
        margin-right: 10px;
        text-align: center;
    }
    .expirationDate{
        width: 40%;
        display: flex;
        align-items: center;
        margin-left: 50px;
    }
    .expirationDate>P{
        width: 25%;
        margin-right: 10px;
        text-align: center;
    }
    /*设置签署方*/
    .signatoryBox{
        /*height: 350px;*/
        background-color: #fff;
    }
    .signatory{
        padding: 30px;
    }
    .signatory>P{
        font-size: 18px;
    }
    /deep/.el-tabs__nav-wrap::after{
        background-color: transparent;
    }
    /deep/.el-tabs__nav-wrap{
        margin: 15px;
    }
</style>
